import i18n from '@/language/i18n';
import EMPLOYEES_WIDGETS from '@/configuration/widgets/EMPLOYEES_WIDGETS';

const EMPLOYEES_MODULE_WINDOW_IDENTIFIER = Object.freeze({
  EMPLOYEES_MODULE_WINDOW_ID: 'employees',
  USERS_MODULE_WINDOW_ID: 'users',
  ROLES_MODULE_WINDOW_ID: 'roles',
  ACCESSGROUPS_MODULE_WINDOW_ID: 'accessgroups',
  OCCUPATION_GROUPS_MODULE_WINDOW_ID: 'occupationgroups',
  GROUPS_MODULE_WINDOW_ID: 'groups',
  DEPARTMENTS_MODULE_WINDOW_ID: 'departments',
  DEPUTY_TYPE_MODULE_WINDOW_ID: 'deputytypes',
  LDAP_SYNCHRONIZATION_WINDOW_ID: 'ldapSynchronization',
  SKILL_MATRIX_MODULE_WINDOW_ID: 'skillmatrix',
  CURRICULUM_VITAE_MODULE_WINDOW_ID: 'curriculumvitae',
  CV_REPORT_MODULE_WINDOW_ID: 'cvreport',
  SKILL_CATEGORIES_MODULE_WINDOW_ID: 'skillcategories',
});

export { EMPLOYEES_MODULE_WINDOW_IDENTIFIER };

export default {
  EMPLOYEES_GROUP_WRAPPER: {
    type: 'group',
    id: 'employees',
    label: i18n.t('ModuleRegistry.groups.personal.name'),
    children: [],
    icon: '$wCustomer',
    sidebarIcon: '$wNavEmployees'
  },
  CHILDREN: {
    EMPLOYEES_MODULE: {
      type: 'module',
      id: 'employeesOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.EMPLOYEES_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.employeesOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_mitarbeiter.svg'),
      routerLink: '/employees',
      globalSearch: {
        index: 'employees',
        presentation: i18n.t(
          'ModuleRegistry.groups.personal.employeesOverview.presentation'
        ),
        component: 'EmployeeItem.vue',
        shortcut: '-e'
      },
      widgets: EMPLOYEES_WIDGETS.EMPLOYEES_OVERVIEW_WIDGETS
    },
    ROLES_MODULE: {
      type: 'module',
      id: 'roleOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.ROLES_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.roleOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_rolle.svg'),
      routerLink: '/roles',
      globalSearch: {
        index: 'roles',
        presentation: i18n.t('ModuleRegistry.groups.personal.roleOverview.label'),
        component: 'RoleItem.vue',
      },
      widgets: EMPLOYEES_WIDGETS.ROLES_WIDGETS
    },
    GROUPS_MODULE: {
      type: 'module',
      id: 'groupOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.GROUPS_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.organisation.group'),
      navigationImg: require('@/assets/navigation/items/icon_gruppe.svg'),
      routerLink: '/groups',
      globalSearch: {
        index: 'groups'
      },
      widgets: EMPLOYEES_WIDGETS.GROUPS_WIDGETS
    },
    DEPARTMENTS_MODULE: {
      type: 'module',
      id: 'departmentOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.DEPARTMENTS_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.departmentsOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/departments',
      globalSearch: {
        index: 'departments'
      },
      widgets: EMPLOYEES_WIDGETS.DEPARTMENT_WIDGETS
    },
    DEPUTY_TYPE_MODULE: {
      type: 'module',
      id: 'deputytypes',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.DEPUTY_TYPE_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.deputyTypeOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/deputytypes',
      globalSearch: {
        index: 'deputytypes'
      },
    },
    LDAP_SYNCHRONIZATION: {
      type: 'module',
      id: 'ldapSynchronization',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.LDAP_SYNCHRONIZATION_WINDOW_ID,
      label: i18n.t('LdapSynchronization.words.ldapSynchronization'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/ldapsynchronization',
      globalSearch: {
        index: 'ldapsynchronization'
      },
    },
    SKILL_MATRIX_MODULE: {
      type: 'module',
      id: 'skillmatrix',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.SKILL_MATRIX_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.skillMatrixOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_mitarbeiter.svg'),
      routerLink: '/skillmatrix',
      globalSearch: {
        index: 'skillmatrix',
      },
    },
    CURRICULUM_VITAE_MODULE: {
      type: 'module',
      id: 'curriculumVitae',
      label: i18n.t('ConfigFixtures.headers.curriculumVitae'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/curriculumvitae',
      globalSearch: {
        index: 'curriculumvitae'
      },
    },
    CV_REPORT_MODULE: {
      type: 'module',
      id: 'cvReport',
      label: i18n.t('CurriculumVitae.words.cvReport'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/cvreport',
      globalSearch: {
        index: 'cv-report'
      },
    },
    SKILL_CATEGORIES_MODULE: {
      type: 'module',
      id: 'skillCategories',
      label: i18n.t('SkillCategories.words.attributes'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/skillcategories',
      globalSearch: {
        index: 'skillcategories'
      },
    }
  }
};
